"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.observers = {};
    }
    EventEmitter.prototype.on = function (events, listener) {
        var _this = this;
        events.split(' ').forEach(function (event) {
            _this.observers[event] = _this.observers[event] || [];
            _this.observers[event].push(listener);
        });
        return this;
    };
    EventEmitter.prototype.off = function (event, listener) {
        if (!this.observers[event])
            return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter(function (l) { return l !== listener; });
    };
    EventEmitter.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this.observers[event]) {
            var cloned = __spreadArray([], __read(this.observers[event]), false);
            cloned.forEach(function (observer) {
                observer.apply(void 0, __spreadArray([], __read(args), false));
            });
        }
        if (this.observers['*']) {
            var cloned = __spreadArray([], __read(this.observers['*']), false);
            cloned.forEach(function (observer) {
                observer.apply(observer, __spreadArray([event], __read(args), false));
            });
        }
    };
    return EventEmitter;
}());
exports.default = EventEmitter;
